<template>
  <div class="d-flex flex-column flex-lg-row flex-column-fluid">
    <div
      class="d-flex flex-column flex-lg-row-auto w-xl-600px positon-xl-relative"
      style="background-color: #f2c98a"
    >
      <div
        class="
          d-flex
          flex-column
          position-xl-fixed
          top-0
          bottom-0
          w-xl-600px
          scroll-y
        "
      >
        <div
          class="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20"
        >
          <a href="/home" class="py-9 mb-5">
            <img
              alt="Logo"
              src="assets/media/logos/terapi-koltugu-logo-1.png"
              class="h-60px"
            />
          </a>
          <h1 class="fw-bolder fs-2qx pb-5 pb-md-10" style="color: #986923">
            Terapi Koltuğu'na Hoşgeldin
          </h1>
          <p class="fw-bold fs-2" style="color: #986923">
            Farklı alanlarda uzman birçok danışmanımızdan anında randevu alıp
            iletişime geçebilirsiniz.
          </p>
        </div>
        <div
          class="
            d-flex
            flex-row-auto
            bgi-no-repeat
            bgi-position-x-center
            bgi-size-contain
            bgi-position-y-bottom
            min-h-100px min-h-lg-350px
          "
          style="
            background-image: url(assets/media/illustrations/sigma-1/13.png;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
          "
        ></div>
      </div>
    </div>
    <div class="d-flex flex-column flex-lg-row-fluid py-10">
      <div class="d-flex flex-center flex-column flex-column-fluid">
        <div class="w-lg-500px p-10 p-lg-15 mx-auto">
          <div
            v-if="!isCodePage"
            class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
            novalidate="novalidate"
          >
            <div class="text-center mb-10">
              <h1 class="text-dark mb-3">Telefon Doğrulama</h1>
              <div class="text-gray-400 fw-bold fs-4">
                Doğrulama kodu gönderebilmemiz için telefon numaranızı başında
                sıfır (0) olmadan 5xxxxxxxxx şeklinde giriniz.
              </div>
            </div>
            <div
              class="fv-row mb-10 fv-plugins-icon-container"
              v-if="countryCodeList"
            >
              <!-- form.countryCode >> {{ form.countryCode }}<br /><br />
              <label class="form-label fs-6 fw-bolder text-dark"
                >Telefon numaranız</label
              > -->

              <div class="formline">
                <treeselect
                  :class="{ selectwidth: selectwidth }"
                  v-model="form.countryCode"
                  :clearable="false"
                  :options="countryCodeList"
                  @open="selectwidth = true"
                  @close="selectwidth = false"
                />

                <input
                  class="form-control form-control-lg form-control-solid"
                  type="text"
                  name="email"
                  autocomplete="off"
                  :placeholder="placeholder"
                  v-model="form.phone"
                  v-numeric="true"
                  v-on:keyup.enter="sendPhoneNumber"
                  maxlength="10"
                />
              </div>
            </div>
            <div class="text-center">
              <div
                class="btn btn-lg btn-primary w-100 mb-5"
                :class="{ '-invalid': !phoneValid }"
                @click="sendPhoneNumber()"
              >
                <span
                  :class="{
                    'indicator-label': !isPhoneSending,
                    'indicator-progress': isPhoneSending,
                  }"
                  >SMS Kodu Gönder</span
                >
                <span
                  :class="{
                    'indicator-label': isPhoneSending,
                    'indicator-progress': !isPhoneSending,
                  }"
                  >Lütfen bekleyin...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span
                ></span>
              </div>
            </div>
            <div></div>
          </div>
          <div
            v-else
            class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
            novalidate="novalidate"
          >
            <div class="text-center mb-10">
              <h1 class="text-dark mb-3">SMS Giriş Kodu</h1>
              <div class="text-gray-400 fw-bold fs-4">
                Lütfen, telefonunuza SMS ile gönderilen doğrulama kodunu
                giriniz.
              </div>
            </div>
            <div class="fv-row mb-10 fv-plugins-icon-container">
              <label class="form-label fs-6 fw-bolder text-dark"
                >SMS Doğrulama Kodu</label
              >
              <input
                class="form-control form-control-lg form-control-solid"
                :class="{ 'is-invalid': apiCodeError }"
                type="text"
                autocomplete="off"
                placeholder="Kodu giriniz"
                v-numeric="true"
                v-model="form.code"
                v-on:keyup.enter="sendSmsCode"
                maxlength="4"
              />
              <div class="fv-plugins-message-container invalid-feedback"></div>
              <div class="fv-plugins-message-container invalid-feedback">
                <div v-if="apiCodeError">Hatalı SMS kodu</div>
              </div>
            </div>
            <div class="text-center">
              <div
                class="btn btn-lg btn-primary w-100 mb-5"
                :class="{ '-invalid': !codeValid }"
                @click="sendSmsCode()"
              >
                <span
                  :class="{
                    'indicator-label': !isCodeSending,
                    'indicator-progress': isCodeSending,
                  }"
                  >Giriş</span
                >
                <span
                  :class="{
                    'indicator-label': isCodeSending,
                    'indicator-progress': !isCodeSending,
                  }"
                  >Lütfen bekleyin...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
        <div class="d-flex flex-center fw-bold fs-6">
          <router-link
            class="text-muted text-hover-primary px-2"
            :to="{ name: 'about' }"
            v-slot="{ href, navigate, isActive }"
          >
            <a :href="href" :class="{ active: isActive }" @click="navigate">
              <span class="menu-title">Hakkımızda</span>
            </a>
          </router-link>
          <router-link
            class="text-muted text-hover-primary px-2"
            :to="{ name: 'contact' }"
            v-slot="{ href, navigate, isActive }"
          >
            <a :href="href" :class="{ active: isActive }" @click="navigate">
              <span class="menu-title">Bize Ulaşın</span>
            </a>
          </router-link>
          <a
            href="https://1.envato.market/EA4JP"
            class="text-muted text-hover-primary px-2"
            target="_blank"
            >Gizlilik</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
import { numeric } from "@/directives/";
import { countryCodeList } from "./countryCodeList";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  data() {
    return {
      form: {
        phone: null,
        code: null,
        countryCode: "+90",
      },
      countryCodeList: null,
      isPhoneSending: false,
      isCodeSending: false,
      isCodePage: false,
      apiCodeError: false,
      selectwidth: false,
    };
  },
  computed: {
    phoneValid: function () {
      if (!this.form.countryCode || !this.form.phone) return false;
      if (
        !this.form.phone ||
        (this.form.countryCode == "+90" &&
          this.form.phone.toString().length != 10)
      )
        return false;
      return true;
    },
    codeValid: function () {
      if (!this.form.code || this.form.code.toString().length != 4)
        return false;
      return true;
    },
    placeholder: function () {
      if (this.form.countryCode == "+90") return "5xxxxxxxxx";

      return "Telefon numaranız";
    },
  },
  watch: {
    "form.code": function () {
      this.apiCodeError = false;
    },
  },
  created() {
    let _body = document.querySelector("body");
    _body.style.backgroundImage = "";
    _body.classList.add("bg-body");
    this.createCountryCodeList();
  },
  directives: { numeric },
  methods: {
    createCountryCodeList: function () {
      let vm = this;

      let list = countryCodeList();
      console.log("list >>", list);
      vm.countryCodeList = list.map((item) => {
        return {
          id: item.key,
          label: `${item.key} / ${item.Name}`,
        };
      });
    },
    sendPhoneNumber: async function () {
      let vm = this;

      if (vm.isPhoneSending || !vm.phoneValid) return;

      vm.isPhoneSending = true;

      let form = {
        phone: vm.form.phone,
      };

      await API.sendPhoneNumber(form);
      setTimeout(() => {
        vm.isCodePage = true;
      }, 500);
    },
    sendSmsCode: async function () {
      let vm = this;

      if (vm.isCodeSending || !vm.codeValid || vm.apiCodeError) return;

      vm.isCodeSending = true;

      let form = {
        phone: vm.form.phone,
        code: vm.form.code,
        countryCode: vm.form.countryCode.replace("+", ""),
      };

      let response = await API.sendSmsCode(form);

      vm.isCodeSending = false;
      if (response.status == "fail") return (this.apiCodeError = true);

      vm.$store.dispatch("setAccessToken", response.data.scalar);
      location.reload();
    },
  },
};
</script>